<template>
  <div style="min-height: 250px; background-color: #FFF" class="row  m-2 p-2 border">
    <div v-if="shares" class="col-md-4 align-self-center text-center">
      <div class="m-3" v-if="shares">
        <span v-if="shares.online" class="badge  m-1 bg-success">ONLINE</span>
        <span v-if="!shares.online" class="badge  m-1 bg-danger">OFFLINE</span>
        <span v-bind:class="{ 'bg-secondary': !shares.progress, 'bg-success': shares.progress  }" class="badge">PROGRESS</span>
        <!-- <span v-if="!shares.progress" class="badge bg-secondary">PROGRESS</span> -->
      </div>
      <img src="./APC.png" height="45" class="m-3"/>
      <h4>APC SmartUPS 750</h4>
      <p>источник бесперебойного питания</p>
    </div>
    <div class="col-md-4 text-center" v-if="shares">
      <h5>Статус</h5>
      <div class="m-3" v-if="shares.info">
        <span v-bind:class="{ 'bg-secondary': !((shares.info.status >> 0) & 1), 'bg-success': ((shares.info.status >> 0) & 1)  }" class="badge m-1">CALIBRATION</span>
        <span v-bind:class="{ 'bg-secondary': !((shares.info.status >> 1) & 1), 'bg-success': ((shares.info.status >> 1) & 1)  }" class="badge m-1">SMARTTRIM</span>
        <span v-bind:class="{ 'bg-secondary': !((shares.info.status >> 2) & 1), 'bg-success': ((shares.info.status >> 2) & 1)  }" class="badge m-1">SMARTBOOST</span>
        <span v-bind:class="{ 'bg-secondary': !((shares.info.status >> 3) & 1), 'bg-success': ((shares.info.status >> 3) & 1)  }" class="badge m-1">ON LINE</span>
        <span v-bind:class="{ 'bg-secondary': !((shares.info.status >> 4) & 1), 'bg-success': ((shares.info.status >> 4) & 1)  }" class="badge m-1">ON BATTERY</span>
        <span v-bind:class="{ 'bg-secondary': !((shares.info.status >> 5) & 1), 'bg-success': ((shares.info.status >> 5) & 1)  }" class="badge m-1">OVERLOAD</span>
        <span v-bind:class="{ 'bg-secondary': !((shares.info.status >> 6) & 1), 'bg-success': ((shares.info.status >> 6) & 1)  }" class="badge m-1">BATTERY LOW</span>
        <span v-bind:class="{ 'bg-secondary': !((shares.info.status >> 7) & 1), 'bg-success': ((shares.info.status >> 7) & 1)  }" class="badge m-1">REPLACE</span>
      </div>
      <h5>Нагрузка</h5>
      <div class="progress">
        <div class="progress-bar bg-danger" :style="{width: shares.info.outputLoad + '%'}" role="progressbar"  aria-valuemin="0" aria-valuemax="100">{{shares.info.outputLoad}}</div>
      </div>
      <p class="m-1">План на {{shares.info.outputRuntime}}мин.</p>
      <!-- {{ shares}} -->
    </div>
    <div class="col-md-4">
      <table v-if="shares" class="table table-striped align-middle">
        <!-- <thead>
          <th>Параметр</th>
          <th>Кол.</th>
        </thead> -->
        <tbody>
          <tr>
            <td>Напряж. Бат.</td>
            <td>{{ shares.info.batteryVoltage }}В</td>
          </tr>
          <tr>
            <td>Уров. Бат.</td>
            <td>{{ shares.info.batteryLevel }}%</td>
          </tr>
          <tr>
            <td>Вх. Напряж.</td>
            <td>{{ shares.info.inputVoltage }}В</td>
          </tr>
          <tr>
            <td>Вх. Частота</td>
            <td>{{ shares.info.inputFreq }}Гц</td>
          </tr>
          <tr>
            <td>Вых. Напряж.</td>
            <td>{{ shares.info.outputVoltage }}В</td>
          </tr>
          <tr>
            <td>Внут. Темп.</td>
            <td>{{ shares.info.upsTemp }}С</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "MU210-401",
  props: ["info", "shares", "id"],
};
</script>
<style scoped>
</style>
